


















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { VipCertificateStatus } from "@/loader";
import CertificatesTable from "./CertificatesTable.vue";

let _id = 0;

@Component({
	components: {
		CertificatesTable
	}
})
export default class CertificatesWidget extends Vue {
	@Prop({ type: String, default: null })
	public status!: VipCertificateStatus | null;

	@Prop({ type: String, default: () => `certificate_widget_${++_id}` })
	public id!: string;

	@Prop({ type: String, default: "Certificats" })
	public title!: string;

	@Prop({ type: String, default: null })
	public accordion!: string | null;

	@Prop({ type: Boolean, default: false })
	public visible!: boolean;

	@Prop({ type: String, default: null })
	public pdfModalId!: string | null;

	public totalRows: number = 0;

	public show() {
		this.$root.$emit("bv::toggle::collapse", this.id);
	}

	public setTotalRows(value: number) {
		this.totalRows = value;
	}
}
